module.exports = __webpack_public_path__ + "img/icon_reviews.be8c6409.svg";